<template>
  <router-link
    v-if="$route.meta.breadcrumb"
    :to="{ name: $route.meta.breadcrumb.name }"
    class="text-white text-center link"
  >
    <i class="fa fa-arrow-circle-left"></i>
    {{ $t('navbar.back') }}
  </router-link>
</template>

<script>
export default {
  name: 'Breadcrumb',
};
</script>

<style lang="sass" scoped>
.link
  font-size: 16px
  margin-left: 5px
  text-decoration: none
  padding: 3px 5px
  border-radius: 5px
  display: flex
  align-items: center
  &:hover
    background-color: rgba(0,0,0,.3)
.fa-arrow-circle-left
  font-size: 23px
  margin-right: .2em
</style>
